import React from 'react';
import { Link } from 'react-router-dom';
import { BlogPost } from '../../types';
import './BlogCard.css';

interface BlogCardProps {
  post: BlogPost;
  onClick?: (post: BlogPost) => void;
}

const BlogCard: React.FC<BlogCardProps> = ({ post, onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick(post);
    }
  };

  return (
    <article className="blog-card">
      <Link to={`/blog/${post.slug}`} className="blog-card__link" onClick={handleClick}>
        <div className="blog-card__image-container">
          <img
            src={post.featuredImage.url}
            alt={post.featuredImage.alt}
            className="blog-card__image"
            loading="lazy"
          />
        </div>
        
        <div className="blog-card__content">
          <span className="category-text">{post.category.name}</span>
          <h3 className="blog-card__title">{post.title}</h3>
        </div>
      </Link>
    </article>
  );
};

export default BlogCard;
